import { CommonModule, Location } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import {
  BENEFICIARIES,
  DATA_UPDATE,
  HOME_URL,
  INICIO,
  ROUTING_TRAMITE_PENSION_INVALIDEZ,
  URL_CAMBIO_AFP_CAPITAL,
  URL_CONTACTO_TRAMITE_PENSION,
  VIDEO_ATENCION,
} from "@constants/url.constant";
import { openClaraChatLauncher } from "@common/utils/open-clara-chat.util";
import { SESSION_TRAMITE_PENSION_INVALIDEZ_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES } from "@shared/common/constants/tramite-pension-invalidez";
import { TramitePensionServiceInvalidez } from "../../service/tramite-pension-invalidez.service";
import { DsButtonV2Component, DsIconComponent } from "@customdesignsystem";
import { PiIndicadorFlujoComponent } from "../../components/pi-indicador-flujo/pi-indicador-flujo.component";
import { GtmService } from "@services/gtm/gtm.service";

@Component({
  selector: "app-request-error",
  templateUrl: "./request-error.component.html",
  styleUrls: ["./request-error.component.scss"],
  imports: [DsIconComponent, CommonModule, DsButtonV2Component, PiIndicadorFlujoComponent],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})

export class RequestErrorComponent implements OnInit {
  error: any;

  constructor(
    private readonly location: Location,
    readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly errorStateService: TramitePensionServiceInvalidez,
    private readonly gtmService: GtmService,
  ) { }

  ngOnInit(): void {
    this.getError();
  }

  ionViewWillEnter() {
    this.getError();
  }

  private getError() {
    this.error = this.errorStateService.getError();

    if (!this.error) {
      this.router.navigate([`/${ROUTING_TRAMITE_PENSION_INVALIDEZ.BASE_URL}`]);
    }
  }

  goBack() {
    this.location.back();
  }

  private clearReintentosErrorGeneral(): void {
    sessionStorage.removeItem(
      SESSION_TRAMITE_PENSION_INVALIDEZ_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES
    );
  }

  goToClick(method: string | undefined) {
    if (!method) {
      return;
    }
    if (method === "goToVideoAtencion") {
      this.clearReintentosErrorGeneral();
      this.errorStateService.clearError();
      this.router.navigate(["/", VIDEO_ATENCION]);
    }
    else if (method === "goToHome") {
      this.router.navigate([`/${ROUTING_TRAMITE_PENSION_INVALIDEZ.BASE_URL}`], {
        relativeTo: this.activatedRoute,
      });
    }
    else if (method === "goToBeneficiario") {
      this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
    }
    else if (method === "goToSolicitudContacto") {
      this.router.navigate([URL_CONTACTO_TRAMITE_PENSION]);
    }
    else if (method === "goToClara") {
      openClaraChatLauncher();
    }
    else if (method === "goToTramitePensionInicio") {
      // Reintentar: vuelve al inicio del trámite. El contador solo baja en cada fallo (home).
      this.errorStateService.clearError();
      this.router.navigate([`/${ROUTING_TRAMITE_PENSION_INVALIDEZ.BASE_URL}`], {
        relativeTo: this.activatedRoute,
        state: { mostrarInicioTramite: true },
      });
    }
    else if (method === "goToAppHome") {
      this.clearReintentosErrorGeneral();
      this.errorStateService.clearError();
      this.router.navigate([INICIO]);
    }
    else if (method === "goToCambiateAfpCapital") {
      this.errorStateService.clearError();
      globalThis.open(URL_CAMBIO_AFP_CAPITAL, "_blank", "noopener,noreferrer");
    }
  }

  goToPage(elemento: string, texto: string, elemento_tipo: string, url: string) {
    this.gtmService.trackClick(elemento, texto, elemento_tipo, url);
    if (url === "/clara") {
      globalThis.document?.getElementById("agente-afp-bubble")?.click();
      return;
    }
    this.router.navigate([`/${url}`]);
  }
}
